import { FormattedMessage } from "react-intl";
import { Toast } from "react-bootstrap";
import { Check2Circle } from "react-bootstrap-icons";

import { useUiFeedback } from "../ui-feedback";
import { closeSuccessFeedback } from "../action";

export const SuccessToast = ({ uuid, msg }) => {
  const { uiFeedbackDispatch } = useUiFeedback();

  const handleClose = () => {
    closeSuccessFeedback(uiFeedbackDispatch, uuid);
  };

  return (
    <Toast
      bg="primary"
      className="mb-2"
      onClose={handleClose}
      show={true}
      delay={5000}
      autohide
    >
      <Toast.Header>
        <Check2Circle className="me-2" />
        <strong className="me-auto">
          <FormattedMessage id="label.successoperation" />
        </strong>
      </Toast.Header>
      <Toast.Body>{msg}</Toast.Body>
    </Toast>
  );
};
